<div class="page-container" *ngIf="formGroup$ | async as formGroup">
  <h1>Auftrag zum Ausbau eines Gaszählers</h1>
  <app-hint-card
    *ngIf="'commissioning.external.gasDecommissioning.pageHint' | uiAdaptionVisible$ | async"
    [outlined]="true"
    [type]="'info'">
    <h2 style="color: inherit">Ihr Netzbetreiber möchte Ihnen folgende Informationen zum Antrag mitteilen</h2>
    <div
      [innerHTML]="
        'commissioning.external.gasDecommissioning.pageHint' | uiAdaptionValue | safeHtmlPipe
      "></div>
  </app-hint-card>
  <div *ngIf="formGroup; else loading">
    <form style="padding-bottom: 2em" [formGroup]="formGroup" formFocusable>
      <mat-vertical-stepper [linear]="true" #stepper>
        <mat-step [stepControl]="formGroup.controls.connectionObjectValid">
          <ng-template matStepLabel>Anschlussobjekt</ng-template>
          <section>
            <app-select-gis-data
              [areaType]="AreaTypeEnum.GAS"
              [disable]="false"
              [inputForm]="formGroup"
              [inputFormAdditionalInfo]="null"
              [listDevelopmentAreas]="[]"
              [selectedGisData]="selectedConnectionObject$ | async"
              [companyLocationsBytenant]="companyLocationsByTenant$ | async"
              [eventsFromParent]="eventsFromParent$"
              (onSelectedGisData)="onGisDataChanged($event, formGroup.controls.connectionObjectValid)" />
          </section>

          <div>
            <button mat-button matStepperNext type="button">Weiter</button>
          </div>
        </mat-step>
        <mat-step errorMessage="Bitte beheben Sie die Fehler" [stepControl]="formGroup.controls['customer']">
          <ng-template matStepLabel>Vertragsnehmer</ng-template>
          <section>
            <app-filiation-form
              [inputFormArray]="formGroup.controls.customer"
              [id]="null"
              [selectedGisData]="selectedConnectionObject$ | async"
              [disableContractPartner]="true"></app-filiation-form>
          </section>

          <div>
            <button mat-button matStepperPrevious type="button">Back</button>
            <button mat-button matStepperNext type="button">Weiter</button>
          </div>
        </mat-step>
        <mat-step [stepControl]="formGroup.controls['supplyAppointment']">
          <ng-template matStepLabel>Durchführungstermin</ng-template>
          <section>
            <app-supply-date
              [isAdminUser]="false"
              [canUpdate]="false"
              [firstDateAvailable]="firstDateAvailable"
              [selectedWishDateOK]="true"
              [selectedWishPartDateOK]="true"
              [areaType]="AreaTypeEnum.GAS"
              [inputForm]="formGroup.controls['supplyAppointment']"></app-supply-date>
            <mat-error
              *ngIf="
                formGroup.controls.supplyAppointment.controls.supplyAppointmentWishDate.touched &&
                formGroup.controls.supplyAppointment.controls.supplyAppointmentWishDate.errors?.minDate
              ">
              Bitte wählen Sie ein Datum ab: {{ firstDateAvailable | date : 'shortDate' }}
            </mat-error>
          </section>

          <div>
            <button mat-button matStepperPrevious type="button">Back</button>
            <button mat-button matStepperNext type="button">Weiter</button>
          </div>
        </mat-step>
        <mat-step [stepControl]="formGroup.controls['meterNumber']">
          <ng-template matStepLabel>Weitere Informationen zum Netzanschluss</ng-template>
          <section>
            <form-row>
              <mat-form-field appearance="outline" fxFlex="70">
                <mat-label>Zählernummer</mat-label>
                <input required matInput type="text" maxlength="90" formControlName="meterNumber" />
              </mat-form-field>
            </form-row>
            <ng-container *ngIf="(commentConfig$ | async) !== FieldConfigEnum.HIDDEN">
              <form-row>
                <mat-form-field fxFlex="70" appearance="outline">
                  <mat-label>Anmerkung zum Antrag</mat-label>
                  <textarea
                    matInput
                    type="text"
                    rows="4"
                    formControlName="comment"
                    maxlength="255"></textarea>
                  <mat-error
                    *ngIf="formGroup.controls.comment.touched && formGroup.controls.comment.errors?.required">
                    Bitte geben Sie einen Grund für Ihren Antrag an
                  </mat-error>
                  <mat-hint>
                    Geben Sie hier den Grund für Ihren Antrag des Gaszählerausbaus an. Sie können auch weitere
                    Informationen mitgeben, die Sie als relevant erachten.
                  </mat-hint>
                </mat-form-field>
              </form-row>
            </ng-container>
          </section>

          <div>
            <button mat-button matStepperPrevious type="button">Back</button>
            <button mat-button matStepperNext type="button">Weiter</button>
          </div>
        </mat-step>
        <mat-step *ngIf="summary$ | async as summary">
          <ng-template matStepLabel>
            <p>Zusammenfassung</p>
          </ng-template>
          <section>
            <app-connection-object-summary
              [connectionObject]="summary.connectionObject"
              [connectionObjectAdditionalInfo]="null"></app-connection-object-summary>
          </section>

          <section>
            <app-filiation-data-summary
              [contactData]="summary.customer"
              [title]="'Vertragsnehmer'"></app-filiation-data-summary>
          </section>

          <!-- Todo: Form hat gar keinen InvoiceContact
          <section *ngIf="outputModel?.invoiceContact">
            <app-filiation-data-summary
              [contactData]="outputModel?.invoiceContact"
              [title]="'Abweichende Rechnungsanschrift'"></app-filiation-data-summary>
          </section>-->

          <section>
            <h2>Durchführungstermin</h2>
            <app-value-with-label
              [label]="'Datum'"
              [value]="summary.supplyAppointmentWishDate | date : 'dd.MM.yyyy'" />
            <app-value-with-label
              [breakLineBefore]="true"
              [label]="'Tageszeit'"
              [value]="summary.supplyAppointmentWishPartday | supplyAppointmentPartDay" />
          </section>
          <section>
            <h2>Technische Informationen</h2>
            <app-value-with-label [label]="'Zählernummer'" [value]="summary.actions[0]?.meterNumber" />
          </section>
          <app-external-privacy-form-field [control]="formGroup.controls.acceptConditions" />

          <section>
            <p>Durch den Gaszählerausbau entstehen Ihnen keinerlei Kosten.</p>
          </section>
          <section>
            <form-row>
              <div
                class="button-container"
                fxLayout="row"
                fxLayoutAlign="space-between center"
                fxLayoutGap="20px"
                fxFlex>
                <app-custom-button
                  [title]="'Ausbau beantragen'"
                  (onClick)="submit(formGroup)"></app-custom-button>
              </div>
            </form-row>
          </section>
        </mat-step>
      </mat-vertical-stepper>
    </form>
  </div>

  <ng-template #loading>
    <app-loading-overlay></app-loading-overlay>
  </ng-template>
</div>
